import { getAddressConfigByCountryCode } from "constants/addressConfig";

const trimOrEmpty = (value) => (value ? String(value).trim() : "");

const trimOrNull = (value) => {
  const trimmed = trimOrEmpty(value);
  return trimmed || null;
};

/** Punch-order address shape (postal_code / state / district strings). */
export const buildAddressPayload = (
  address,
  { countryId, isdCode, countryCode } = {}
) => {
  if (!address) {
    return null;
  }

  const config = getAddressConfigByCountryCode(countryCode);

  const payload = {
    country_id: Number(countryId),
    city: trimOrEmpty(address.city),
    address_line_1: trimOrNull(address.addressLine1),
    address_line_2: trimOrNull(address.addressLine2),
    street: trimOrNull(address.street),
    recipient_name: trimOrEmpty(address.recipientName),
    recipient_phone_number: trimOrEmpty(address.recipientPhoneNumber),
    isd_code: isdCode || "",
    email: trimOrNull(address.recipientEmail),
    parent_name: trimOrNull(address.parentName),
    landmark: trimOrNull(address.landmark),
  };

  const postalCode = trimOrNull(address.pincode);
  if (
    postalCode &&
    (config.requirePostalCodeId ||
      config.requirePostalCode ||
      config.showPostalCode)
  ) {
    payload.postal_code = postalCode;
  }

  const district = trimOrNull(address.district);
  if (
    district &&
    (config.requirePostalCodeId ||
      config.requireDistrictName ||
      config.showDistrict)
  ) {
    payload.district = district;
  }

  const state = trimOrNull(address.state);
  if (
    state &&
    (config.requirePostalCodeId ||
      config.requireStateName ||
      config.showState)
  ) {
    payload.state = state;
  }

  return payload;
};

/**
 * Order-modification / transfer address shape
 * (postal_code_id / district_id / state_id + country_name).
 */
export const buildOrderModificationAddressPayload = (
  address,
  { countryId, isdCode, countryCode, countryName } = {}
) => {
  if (!address) {
    return null;
  }

  const config = getAddressConfigByCountryCode(countryCode);

  const payload = {
    country_id: Number(countryId),
    country_name: countryName || "",
    city: trimOrEmpty(address.city),
    address_line_1: trimOrNull(address.addressLine1),
    address_line_2: trimOrNull(address.addressLine2),
    street: trimOrNull(address.street),
    recipient_name: trimOrEmpty(address.recipientName),
    recipient_phone_number: trimOrEmpty(address.recipientPhoneNumber),
    isd_code: isdCode || "",
    email: trimOrNull(address.recipientEmail),
    parent_name: trimOrNull(address.parentName),
    landmark: trimOrNull(address.landmark),
  };

  if (config.requirePostalCodeId) {
    payload.postal_code_id = address.pincodeId;
    payload.district_id = address.districtId;
    payload.state_id = address.stateId;
  }

  if (config.requirePostalCodeId && address.district) {
    payload.district_name = trimOrEmpty(address.district);
  }

  if (config.requirePostalCodeId && address.state) {
    payload.state_name = trimOrEmpty(address.state);
  }

  if (config.requireDistrictName) {
    payload.district_name = trimOrEmpty(address.district);
  }

  if (config.requirePostalCode) {
    payload.pincode = trimOrEmpty(address.pincode);
  }

  if (config.requireStateName) {
    payload.state_name = trimOrEmpty(address.state);
  }

  return payload;
};
